// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import ClipboardController from "./clipboard_controller"
import BuilderController from "./builder_controller"
import TokenRevealController from "./token_reveal_controller"
import SignoutModalController from "./signout_modal_controller"
import ConfirmModalController from "./confirm_modal_controller"
import TritonStatusController from "./triton_status_controller"
import UsageChartsController from "./usage_charts_controller"

application.register("hello", HelloController)
application.register("clipboard", ClipboardController)
application.register("builder", BuilderController)
application.register("token-reveal", TokenRevealController)
application.register("signout-modal", SignoutModalController)
application.register("confirm-modal", ConfirmModalController)
application.register("triton-status", TritonStatusController)
application.register("usage-charts", UsageChartsController)
